import React, { useEffect, useRef } from "react";
import herobgcover from "../../../../assets/images/herobgcover.png";
import { useInView } from "react-intersection-observer";
import scrolldown from "../../../../assets/icons/scrolldown.svg";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import {
    Fade,
    Hinge,
    JackInTheBox,
    Roll,
    Slide,
    Zoom,
} from "react-awesome-reveal";
import { Link } from "react-router-dom";

function HeroTwo({
    setIsLargeScreen,
    isLargeScreen,
    isPage,
    setisPage,
    data,
    pageInView,
    setPageInView,
}) {
    const sceneRef = useRef(null);
    const imgRef = useRef(null);
    const { ref, inView, entry } = useInView({
        triggerOnce: false,
        threshold: 0.5,
    });
    useEffect(() => {
        if (inView) {
            console.log("pageview is mission");
            if (inView) {
                setPageInView("secondpage");
            }
        }
    }, [inView]);
    useEffect(() => {
        const handleScroll = () => {
            if (sceneRef.current && imgRef.current) {
                const scrollY = window.scrollY;
                const translateY = scrollY * -0.7;

                gsap.to(imgRef.current, {
                    y: translateY,
                    duration: 0.5,
                    ease: "power2.out",
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        gsap.registerPlugin(SplitText);
        const innovationpara = new SplitText("#innovationpara", {
            type: "words",
        });

        gsap.from(innovationpara.words, {
            duration: 3,
            opacity: 0,
            ease: "power1.inOut",
            stagger: {
                each: 0.13,
                from: "start",
            },
        });

        return () => {
            innovationpara.revert();
        };
    }, []);

    const handlePagination = (item, number) => {
        scrollToElement(item);
        setisPage(number);
    };
    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
        }
        console.log("clicked", id);
        if (element) {
            gsap.to(window, {
                scrollTo: {
                    y: element.offsetTop,
                    offsetY: 300,
                },
                ease: "power2.inOut",
            });
        }
    };
    const renderQuestion = (question) => {
        return question.split("\n").map((text, index) => (
            <React.Fragment key={index}>
                {text}
                <br />
            </React.Fragment>
        ));
    };
    return (
        <div
            ref={ref}
            className="relative overflow-hidden text-center flex flex-col pt-[200px] z-10 px-5 lg:px-10"
            id="secondpage"
        >
            <div className="pb-[60px] z-20 text-white relative w-full md:w-[90%] mx-auto text-left">
                {isLargeScreen ? (
                    <div>
                        <div className="absolute top-[-220px] inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                        <div className="absolute top-[-220px] inset-y-0 left-1/3 w-px bg-white/10 z-0"></div>
                        <div className="absolute top-[-220px] inset-y-0 left-2/3 w-px bg-white/10 z-0"></div>
                        <div className="absolute top-[-220px] inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                    </div>
                ) : (
                    <div>
                        <div className="absolute top-[-220px] inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                        <div className="absolute top-[-220px] inset-y-0 left-1/2 w-px bg-white/10 z-0"></div>
                        <div className="absolute top-[-220px] inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                        <div className="absolute inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                        <div className="absolute inset-y-0 left-1/2 w-px bg-white/10 z-0"></div>
                        <div className="absolute inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                    </div>
                )}
                <div className="w-full mt-[-100px] lg:mt-24 h-full min-h-[50vh] flex-col">
                    <div className="flex-col lg:flex-row flex">
                        <div className="w-full lg:w-1/3 flex flex-col md:mb-10 md:flex-col sm:mt-0 mt-24 gap-3 md:gap-5">
                            <Slide direction="left" triggerOnce>
                                <p className="h8">OUR SERVICES</p>

                            </Slide>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-x-5 mt-10">
                        {data.secondPage.map((item) => (
                            <div
                                key={item.id}
                                className="flex flex-col justify-start"
                            >
                                <Fade triggerOnce>
                                    <p className="text-[24px] leading-[32px] sm:text-[28px] sm:leading-[38px] lg:text-[32px] lg:leading-[42px] xl:text-[36px] xl:leading-[48px] mb-4 font-semibold">
                                        {renderQuestion(item.question)}
                                    </p>
                                </Fade>
                                <Zoom triggerOnce>
                                    <h6 className="text-[16px] leading-[24px] sm:text-[18px] sm:leading-[27px] lg:text-[16px] lg:leading-[24px] xl:text-[18px] xl:leading-[27px] text-gray-300 h15">
                                        {item.answer}
                                    </h6>
                                </Zoom>
                            </div>
                        ))}
                    </div>
                </div>
                <p className="text-left flex lg:flex-row flex-col justify-start mt-[200px] h8">
                    OUR PROJECTS
                </p>
            </div>
        </div>
    );
}

export default HeroTwo;